import { Node, mergeAttributes } from '@tiptap/core';
import { createAutoPaginationPlugin } from './AutoPaginationPlugin';

export interface PageBreakSpacerOptions {
  HTMLAttributes: Record<string, any>;
  autoPagination: boolean;
  pageHeight: number;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    pageBreakSpacer: {
      /**
       * Add a page break spacer
       */
      setPageBreakSpacer: () => ReturnType;
    };
  }
}

export const PageBreakSpacer = Node.create<PageBreakSpacerOptions>({
  name: 'pageBreakSpacer',

  addOptions() {
    return {
      HTMLAttributes: {},
      autoPagination: false,
      pageHeight: 1255,
    };
  },

  group: 'block',

  addAttributes() {
    return {
      height: {
        default: 150,
        parseHTML: element => parseInt(element.getAttribute('data-height') || '150'),
        renderHTML: attributes => {
          return {
            'data-height': attributes.height,
            style: `height: ${attributes.height}px; min-height: ${attributes.height}px;`,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="page-break-spacer"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes, node }) {
    const height = node.attrs.height || 150;
    return [
      'div',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        'data-type': 'page-break-spacer',
        'class': 'page-break-spacer',
        'data-height': height,
        style: `height: ${height}px !important; min-height: ${height}px !important;`,
      }),
    ];
  },

  addCommands() {
    return {
      setPageBreakSpacer:
        () =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
          });
        },
    };
  },

  addProseMirrorPlugins() {
    return [
      createAutoPaginationPlugin({
        enabled: this.options.autoPagination,
        pageHeight: this.options.pageHeight,
      }),
    ];
  },
});
